import type { DTOOf, IRefreshRunStatus, IWorkOrderSyncAction } from '@atlas/types'
import { apiClient } from './api.client'

/** One work order's action for one bundle version, as `GET /work-orders/sync-actions` returns it. */
export type WorkOrderSyncActionDTO = DTOOf<IWorkOrderSyncAction>

/** A refresh from Workfront as the work order page polls it. */
export type RefreshRunStatus = IRefreshRunStatus

const unwrap = <T>(body: { data: T }): T => body.data

/** The work-order side of the Workfront sync: refreshing one order's bundle, and the recorded actions. */
export const workOrderSyncApi = {
	/** Starts a sync of the order's whole Workfront bundle; 409 while the bundle is already syncing. */
	refreshFromWorkfront: (workOrderId: string): Promise<{ runId: string }> =>
		apiClient
			.post<{ data: { runId: string } }>(`/work-orders/${workOrderId}/refresh-from-workfront`)
			.then((r) => unwrap(r.data)),
	refreshRun: (workOrderId: string, runId: string): Promise<RefreshRunStatus> =>
		apiClient
			.get<{ data: RefreshRunStatus }>(`/work-orders/${workOrderId}/refresh-from-workfront/${runId}`)
			.then((r) => unwrap(r.data)),
	/** The actions recorded for a bundle version, shadow or live; the latest version when none is named. Admin only. */
	syncActions: (bundleId: string, version?: number): Promise<WorkOrderSyncActionDTO[]> =>
		apiClient
			.get<{ data: WorkOrderSyncActionDTO[] }>('/work-orders/sync-actions', {
				params: { bundleId, ...(version === undefined ? {} : { version }) },
			})
			.then((r) => unwrap(r.data)),
}
